import { useState, useCallback } from "react";
import Slider from "../../components/calculator/Slider";
import styles from "./Calculator.module.css";
import Input from "../Input";
import { cmToFeet, feetToCM, poundToKg } from "../../utils/heightHelpers";

const Bmi = () => {
  const [weightMetric, setWeightMetric] = useState("kg");
  const [heightMetric, setHeightMetric] = useState("ft");
  const [height, setHeight] = useState(0);
  const [weight, setWeight] = useState(0);
  const [foot, setFoot] = useState(0);
  const [inches, setInches] = useState(0);

  const renderText = () => {
    const bmi = calculateBMI(height, weight);
    // if (bmi < 18.5) {
    //   return "Underweight";
    // } else if (bmi > 18.5 && bmi < 25) {
    //   return "Normal";
    // } else if (bmi >= 25 && bmi < 30) {
    //   return "Overweight";
    // } else if (bmi >= 30 && bmi < 35) {
    //   return "Obese";
    // } else if (bmi >= 35) {
    //   return "Extremely Obese";
    // }
    if (bmi < 16) {
      return "Underweight (Severe)";
    } else if (bmi >= 16 && bmi < 17) {
      return "Underweight (Moderate)";
    } else if (bmi >= 17 && bmi < 18.5) {
      return "Underweight (Mild)";
    } else if (bmi >= 18.5 && bmi < 25) {
      return "Normal";
    } else if (bmi >= 25 && bmi < 30) {
      return "Overweight (Pre-Obese)";
    } else if (bmi >= 30 && bmi < 35) {
      return "Obesity (Extreme)";
    } else if (bmi >= 35 && bmi < 40) {
      return "Obesity (Morbid)";
    } else if (bmi >= 40) {
      return "Obesity (Fatal)";
    }
  };

  const calculateBMI = (height, weight) => {
    const w = weightMetric === "kg" ? weight : poundToKg(weight);
    console.log(w, parseInt(height), weight);
    const res = (w / ((height * height) / 10000)).toFixed(1);
    return res > 0 && res < 150 ? res : 0.0;
  };

  const calculateDeg = () => {
    const bmi = calculateBMI(height, weight);
    if (bmi < 18.5) {
      return -90;
    } else if (bmi > 18.5 && bmi < 25) {
      return 317 - 360;
    } else if (bmi >= 25 && bmi < 30) {
      return 0;
    } else if (bmi >= 30 && bmi < 35) {
      return 43;
    } else if (bmi >= 35) {
      return 77;
    }
  };

  const heightChangeHandler = useCallback((e) => {
    const value = e.target.value;
    switch (e.target.name) {
    case "heightFoot":
        value ? setFoot(parseFloat(value)) : setFoot('');
        setHeight(feetToCM(e.target.value, inches));
        break;
    case "heightInches":
        value ? setInches(parseFloat(value)) : setInches('');
        setHeight(feetToCM(foot, e.target.value));
        break;
    default:
      break;
    }
  }, [foot, inches]);

  const heightSliderChangeHandler = useCallback((value) => {
    setHeight(value);
    switch(heightMetric){
      case 'ft':
        const [dft, dinches] = cmToFeet(value);
        setFoot(dft);
        setInches(dinches);
        break;
      case 'cm':
        setFoot(value);
        break;
      case 'm':
        setFoot(value/100);
        break;
      default:
        break;
    }

  }, [heightMetric]);

  const weightHandler = (e) => {
      setWeight(e.target.value);
  };

  return (
    <div>
      <div className="row ms-0 me-0 mt-3 bmi_calculator">
        <div className="col-xl-6 m-auto">
          <div className="row m-0">
            <div className="col-6 col-sm-8 col-md-8 m-auto p-0">
              <div className="fo-18 fw-600 txtco">Weight</div>
            </div>
            <div className="col-3 col-sm-2 col-md-2 m-auto p-1">
              <Input
                value={weight}
                className="w-100 calculatorInput"
                onChange={weightHandler}
                max={weightMetric === "kg" ? 150: 300}
              />
            </div>
            <div className="col-3 col-sm-2 col-md-2 m-auto p-0">
              <div className="buttonGroups">
                <select
                  className="calculatorInput2 txtco fw-700"
                  value={weightMetric}
                  onChange={(e) => setWeightMetric(e.target.value)}
                >
                  <option value="kg">Kg</option>
                  <option value="lbs">Lbs</option>
                </select>
              </div>
            </div>
          </div>

          <Slider
            name="weight"
            value={weight}
            onChange={(value) => setWeight(value)}
            min={0}
            max={weightMetric === "kg" ? 150 : 300}
            key={"weight"}
          />

          <div className="row m-0">
            <div className="col-6 col-sm-8 col-md-8 m-auto p-0">
              <div className="fo-18 fw-600 txtco">Height</div>
            </div>
            <div className="col-3 col-sm-2 col-md-2 m-auto p-1">
              <Input
                name="heightFoot"
                className="w-100 calculatorInput"
                value={foot}
                max={7}
                min={1}
                onChange={heightChangeHandler}
              />
            </div>
            <div className="col-3 col-sm-2 col-md-2 m-auto p-0">
              <select
                className="calculatorInput2 txtco fw-700"
                onChange={(e) => setHeightMetric(e.target.value)}
              >
                <option value="ft">Ft</option>
                <option value="cm">cm</option>
                <option value="m">m</option>
              </select>
            </div>
          </div>

          {heightMetric === "ft" && (
            <div className="row m-0">
              <div className="col-6 col-sm-8 col-md-8 m-auto p-0"></div>
              <div className="col-3 col-sm-2 col-md-2 m-auto p-1">
                <Input
                  name="heightInches"
                  className="w-100 calculatorInput"
                  value={inches}
                  max={12}
                  min={0}
                  onChange={heightChangeHandler}
                />
              </div>
              <div className="col-3 col-sm-2 col-md-2 m-auto p-0">
                <div className="buttonGroups">
                  <div className="button2 fw-700 text-start">In</div>
                </div>
              </div>
            </div>
          )}

          <Slider
            name="height"
            value={height}
            onChange={heightSliderChangeHandler}
            min={0}
            max={250}
          />

          <div className="row m-0 bmi_result">
            <div className="col-6 col-sm-8 m-auto p-0">
              <div className="fo-18 fw-700 text-white mfo-13">
                Your BMI is{" "}
                {calculateBMI(height, weight) > 0
                  ? calculateBMI(height, weight)
                  : "0.0"}
              </div>
            </div>
            <div className="col-6 col-sm-4 m-auto p-0 text-center">
              <div className="fo-18 fw-700 text-white mfo-13">
                {renderText()}
              </div>
            </div>
          </div>
        </div>

        <div className={`col-xl-6 mt-3 m-sm-auto ${styles.meterContainer}`}>
          <img
            src="/assets/bmi/background2.svg"
            className={`${styles.meterBackground}`}
            alt="BMI Image"
          />
          <img
            src="/assets/bmi/needle.png"
            className={`${styles.meterNeedle}`}
            style={{ transform: `rotate(${calculateDeg()}deg)` }}
            alt="BMI Image"
          />
        </div>
      </div>
    </div>
  );
};

export default Bmi;
